var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.71 57.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.94,
    cy: 19.29,
    r: 13.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.23,31.94V37a5.29,5.29,0,0,1-5.29,5.29h0A5.29,5.29,0,0,1,34.65,37V32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.65,34.59c-6.93.89-12.21,5.48-12.21,11h0a9.47,9.47,0,0,0,9.46,9.46h16A9.47,9.47,0,0,0,57.3,45.6v-.08h0c0-5.36-5-9.84-11.59-10.92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.39,24.38a11.65,11.65,0,1,1,2.78-19.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.34,24.37v4.3a4.49,4.49,0,0,1-4.48,4.48h0a4.48,4.48,0,0,1-4.48-4.48V24.43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.38,26.62C6.5,27.37,2,31.26,2,35.94H2a8,8,0,0,0,8,8h5.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.32,24.38a11.65,11.65,0,1,0-2.78-19.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.37,24.37v4.3a4.48,4.48,0,0,0,4.48,4.48h0a4.48,4.48,0,0,0,4.48-4.48V24.43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.33,26.62c5.88.75,10.35,4.64,10.35,9.32h0a8,8,0,0,1-8,8h-5.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.576a3033.svg";
export { ForwardRef as ReactComponent };